import React, { useContext } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { NavigationContext } from '../../context/NavigationContext';
import Button from '../Button';
import ButtonEntry from './ButtonEntry';

const defaultStyles = {
    lineHeight: 1,
    textDecoration: 'none',
    display: 'flex',
    position: 'relative',
};

const PornhubPremiumAddonId = 5411;

const DynamicGroupComponent = styled.div(({ styles }) => styles);

const DynamicGroup = ({
    styles: {
        mainButton,
        subButton,
    } = {},
    structureType,
    attributes,
    attributes: { dataType } = {},
    isChildButton,
    ...props
}) => {
    const { dynamicContent = {} } = useContext(NavigationContext);
    const content = dynamicContent[dataType];

    if (!content) {
        return null;
    }

    let { collection = [] } = content;
    const { linkQueryKey, linkType } = content;

    if (linkQueryKey === 'addon') {
        collection = collection.map(item => {
            if (item.id === PornhubPremiumAddonId) {
                return {
                    ...item,
                    linkType: 'MY_LIBRARY',
                };
            }

            return item;
        });
    }

    return (
        <DynamicGroupComponent
            {...props}
            styles={{ ...defaultStyles, ...(isChildButton && { flexDirection: 'column' }) }}
        >
            {isChildButton && structureType === 'mobile' ? (
                <>
                    <Button
                        attributes={attributes}
                        structureType={structureType}
                        styles={mainButton}
                        isChildButton={isChildButton}
                        {...props}
                    />
                    {collection.map((item, key) => (
                        <ButtonEntry
                            // eslint-disable-next-line react/no-array-index-key
                            key={key}
                            {...item}
                            linkQueryKey={linkQueryKey}
                            linkType={item.linkType || linkType}
                            structureType={structureType}
                            styles={subButton}
                        />
                    ))}
                </>
            ) : (
                <Button
                    attributes={attributes}
                    structureType={structureType}
                    styles={mainButton}
                    isChildButton={isChildButton}
                    {...props}
                >
                    {collection.map((item, key) => (
                        <ButtonEntry
                            // eslint-disable-next-line react/no-array-index-key
                            key={key}
                            {...item}
                            linkQueryKey={linkQueryKey}
                            linkType={item.linkType || linkType}
                            structureType={structureType}
                            styles={subButton}
                        />
                    ))}
                </Button>
            )}
        </DynamicGroupComponent>
    );
};

DynamicGroup.propTypes = {
    isChildButton: PropTypes.bool,
    styles: PropTypes.object,
    structureType: PropTypes.string,
    attributes: PropTypes.object,
};

export default DynamicGroup;
